import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'
import FieldsCreditAmount from 'graphql/fields/FieldsCreditAmount';

const fields = {
	'employee_guid': 'String!',
	'timeslot_kind_guid': 'String!',
	'amount': 'Int!',
};

export default gql(`
	mutation employee_credit_change( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_credit_change( ${ HelperGraphql.createVariables( fields ) } ) {
	      	${ FieldsCreditAmount }
	    }
	}
`);

